import { defineMessages } from 'react-intl'

export const featuresMessages = [
  defineMessages({
    icon: {
      id: 'djcity.common.marketing.feature1.icon',
      defaultMessage: '/assets/cdn/mixer_a.png',
    },
    title: {
      id: 'djcity.common.marketing.feature1.title',
      defaultMessage: 'Bulk Downloads',
    },
    subTitle: {
      id: 'djcity.common.marketing.feature1.subTitle',
      defaultMessage:
        'Automatically download multiple songs at once using your phone or browser.',
    },
    url: {
      id: 'djcity.common.marketing.feature1.url',
      defaultMessage: '/home',
    },
  }),
  defineMessages({
    icon: {
      id: 'djcity.common.marketing.feature2.icon',
      defaultMessage: '/assets/cdn/mixer_b.png',
    },
    title: {
      id: 'djcity.common.marketing.feature2.title',
      defaultMessage: 'Curated Playlists',
    },
    subTitle: {
      id: 'djcity.common.marketing.feature2.subTitle',
      defaultMessage:
        'The latest hits from the genres that matter the most, including Afrobeats and Lounge Essentials.',
    },
    url: {
      id: 'djcity.common.marketing.feature2.url',
      defaultMessage: '/playlists',
    },
  }),
  defineMessages({
    icon: {
      id: 'djcity.common.marketing.feature3.icon',
      defaultMessage: '/assets/cdn/mixer_c.png',
    },
    title: {
      id: 'djcity.common.marketing.feature3.title',
      defaultMessage: 'Cloud Sync',
    },
    subTitle: {
      id: 'djcity.common.marketing.feature3.subTitle',
      defaultMessage: 'Synchronization across devices.',
    },
    url: {
      id: 'djcity.common.marketing.feature3.url',
      defaultMessage: '/exclusives',
    },
  }),
  defineMessages({
    icon: {
      id: 'djcity.common.marketing.feature4.icon',
      defaultMessage: '/assets/cdn/microphone.png',
    },
    title: {
      id: 'djcity.common.marketing.feature4.title',
      defaultMessage: 'Enhanced Search',
    },
    subTitle: {
      id: 'djcity.common.marketing.feature4.subTitle',
      defaultMessage:
        'Powerful search and filters to quickly find the songs you need.',
    },
    url: {
      id: 'djcity.common.marketing.feature4.url',
      defaultMessage: '/home',
    },
  }),
  defineMessages({
    icon: {
      id: 'djcity.common.marketing.phone',
      defaultMessage: '/assets/cdn/marketing_phone.png',
    },
    title: {
      id: 'djcity.common.marketing.music.title',
      defaultMessage: 'MUSIC AT YOUR FINGERTIPS.',
    },
    subTitle: {
      id: 'djcity.common.marketing.music.subtitle',
      defaultMessage: 'WITH OPTIMIZED DIGITAL APPS.',
    },
    url: {
      id: 'djcity.common.marketing.music.url',
      defaultMessage: '/apps',
    },
  }),
  defineMessages({
    icon: {
      id: 'djcity.common.marketing.feature5.icon',
      defaultMessage: '/assets/cdn/fabio_alves.png',
    },
    button: {
      id: 'djcity.common.marketing.feature5.button',
      defaultMessage: 'Explore catalog',
    },
    url: {
      id: 'djcity.common.marketing.feature5.url',
      defaultMessage: '/home',
    },
  }),
]

export const localizedMessages = defineMessages({
  hero_title1: {
    id: 'djcity.common.marketing.heroTitle.line1',
    defaultMessage: 'The record pool',
  },
  hero_title2: {
    id: 'djcity.common.marketing.heroTitle.line2',
    defaultMessage: "for the world's best DJs",
  },
  hero_content: {
    id: 'djcity.common.marketing.heroContent',
    defaultMessage:
      '<span className="emphasis">DJcity</span> is the leading music discovery + delivery platform for DJs around the world. Rock any party with the hottest tracks at your fingertips.',
  },
  subscribeNow: {
    id: 'djcity.common.marketing.subscribenow',
    defaultMessage: 'Subscribe Now',
  },
  subscribeNowFor: {
    id: 'djcity.common.marketing.subscribenowfor',
    defaultMessage: 'Subscribe now for {currency}{price}.',
  },
  getStartedNow: {
    id: 'djcity.common.marketing.getStartedNow',
    defaultMessage: 'Get Started',
  },
  forJust: {
    id: 'djcity.common.marketing.forJust',
    defaultMessage: 'for just',
  },
  forOnly: {
    id: 'djcity.common.marketing.forOnly',
    defaultMessage: 'for only',
  },
  getStartedToday: {
    id: 'djcity.common.marketing.getStarted',
    defaultMessage: 'Get started today',
  },
  marketing_subscription: {
    id: 'djcity.common.marketing.subscription',
    defaultMessage: 'SUBSCRIPTION',
  },
  marketing_benefits: {
    id: 'djcity.common.marketing.benefits',
    defaultMessage: 'BENEFITS',
  },
  marketing_bulkDownload: {
    id: 'djcity.common.marketing.bulkDownload',
    defaultMessage: 'Bulk Download',
  },
  marketing_curatedPlaylist: {
    id: 'djcity.common.marketing.curatedPlaylist',
    defaultMessage: 'Curated Playlist',
  },
  marketing_enhancedSearch: {
    id: 'djcity.common.marketing.enhancedSearch',
    defaultMessage: 'Enhanced Search',
  },
  marketing_devices: {
    id: 'djcity.common.images.devices',
    defaultMessage: '/assets/cdn/marketing_devices.png',
  },
  marketing_devices_alt: {
    id: 'djcity.common.images.devices.alt',
    defaultMessage: 'Devices',
  },
  marketing_dj: {
    id: 'djcity.common.images.dj',
    defaultMessage: '/assets/cdn/marketing_dj.jpg',
  },
  marketing_mixer: {
    id: 'djcity.common.images.mixer',
    defaultMessage: '/assets/cdn/mixer.png',
  },
  marketing_main_dj_banner: {
    id: 'djcity.common.images.main_dj_banner',
    defaultMessage: '/assets/cdn/main_dj_banner.png',
  },
  marketing_homepage_background: {
    id: 'djcity.common.images.homepage_background',
    defaultMessage: '/assets/cdn/homepage_background.png',
  },
  marketing_poolsContent: {
    id: 'djcity.common.marketing.poolsContent',
    defaultMessage:
      '<b>Five record pools, one price.</b> Tracks directly sourced from regional powerhouses including the <a href="/monthly-charts">United States</a>, <a href="/monthly-charts?regionId=3">United Kingdom</a>, <a href="/monthly-charts?regionId=4">Germany</a>, <a href="/monthly-charts?regionId=2">Japan</a> & <a href="/monthly-charts?regionId=6">Latin America</a>.  Your subscription includes full access to all five DJcity record pools for the price of one.',
  },
  marketing_poolsImage: {
    id: 'djcity.common.images.globe',
    defaultMessage: '/assets/cdn/globe.svg',
  },
  marketing_poolsTitle: {
    id: 'djcity.common.marketing.worldmusic',
    defaultMessage: 'Music from around the <span>world</span>',
  },
  marketing_version: {
    id: 'djcity.common.images.version',
    defaultMessage: '/assets/cdn/marketing_version.png',
  },
  marketing_version_alt: {
    id: 'djcity.common.images.version.alt',
    defaultMessage: 'Versions',
  },
  marketing_crowd_banner: {
    id: 'djcity.common.images.crowd',
    defaultMessage: '/assets/cdn/crowd.png',
  },
  newUsersOnly: {
    id: 'djcity.common.marketing.newUsersOnly',
    defaultMessage: '* New Users Only',
  },
  exclusives_title: {
    id: 'djcity.common.marketing.exclusives.title',
    defaultMessage: 'EXCLUSIVE REMIXERS & <span>PRODUCERS</span>',
  },
  exclusives_content: {
    id: 'djcity.common.marketing.exclusives.content',
    defaultMessage:
      'Exclusive releases from DJcitys team of remixers and producers. You won’t find these tracks anywhere else on the internet.',
  },
  exclusives_remixer: {
    id: 'djcity.common.marketing.exclusives.image',
    defaultMessage: '/assets/cdn/djc_remixer.png',
  },
  exclusives_remixers: {
    id: 'djcity.common.marketing.exclusives.remixers',
    defaultMessage: '/assets/cdn/djc_remixers.png',
  },
  exclusives_remixersAlt: {
    id: 'djcity.common.marketing.exclusives.imageAlt',
    defaultMessage: 'Remixers on App',
  },
  exclusives_tracks: {
    id: 'djcity.common.marketing.exclusives.tracks',
    defaultMessage: 'Access to <p>7 MILLION<span>+</span></p> tracks worldwide',
  },
  integrations: {
    id: 'djcity.common.marketing.effortlessintegration',
    defaultMessage: 'Effortless DJ software integration',
  },
  music_background: {
    id: 'djcity.common.marketing.music.background',
    defaultMessage: '/assets/cdn/djc_mixer.png',
  },
  music_image: {
    id: 'djcity.common.marketing.music.image',
    defaultMessage: '/assets/cdn/djc_devices.png',
  },
  music_content: {
    id: 'djcity.common.marketing.music.content',
    defaultMessage:
      'Fully optimized Desktop and Mobile apps for easy browsing and bulk track downloads.',
  },
  pricing_getStarted: {
    id: 'djcity.common.marketing.pricing.getStarted',
    defaultMessage: "Let's get started.",
  },
  pricing_getStartedToday: {
    id: 'djcity.common.marketing.pricing.getStartedToday',
    defaultMessage: 'Subscribe today.',
  },
  faq_title: {
    id: 'djcity.common.marketing.faq.title',
    defaultMessage: 'FAQ',
  },
  faq_subtitle: {
    id: 'djcity.common.marketing.faq.subtitle',
    defaultMessage:
      'Find out why DJcity is the best record pool for both beginner and expert DJs!',
  },
  menu_1: {
    id: 'djcity.common.marketing.menu_button.1',
    defaultMessage: 'Price',
  },
  menu_2: {
    id: 'djcity.common.marketing.menu_button.2',
    defaultMessage: 'Compare',
  },
  menu_3: {
    id: 'djcity.common.marketing.menu_button.3',
    defaultMessage: 'Integrations',
  },
  menu_4: {
    id: 'djcity.common.marketing.menu_button.4',
    defaultMessage: 'Reviews',
  },
  menu_5: {
    id: 'djcity.common.marketing.menu_button.5',
    defaultMessage: 'FAQ',
  },
  menu_6: {
    id: 'djcity.common.marketing.menu_button.6',
    defaultMessage: 'Join now',
  },
})

export const promoMessages = defineMessages({
  background: {
    id: 'djcity.common.marketing.promo.background',
    defaultMessage: '/assets/cdn/promo_background.png',
  },
  title: {
    id: 'djcity.common.marketing.promo.title',
    defaultMessage: "The record pool for the world's best DJs",
  },
  subtitle: {
    id: 'djcity.common.marketing.promo.subtitle',
    defaultMessage: 'Limited time only.',
  },
  price: {
    id: 'djcity.common.marketing.promo.price',
    defaultMessage: 'Subscribe for {currency}{price}.',
  },
  price_footer: {
    id: 'djcity.common.marketing.promo.price_footer',
    defaultMessage: 'Subscribe for {currency}{price}.',
  },
  signup_title: {
    id: 'djcity.common.marketing.promo.signup.title',
    defaultMessage:
      'Create an account and get your subscription now for just <b>{currency}{price}</b>!',
  },
  signup_subtitle: {
    id: 'djcity.common.marketing.promo.signup.subtitle',
    defaultMessage: 'This deal is exclusively for new users.*',
  },
  signup_firstname: {
    id: 'djcity.common.marketing.promo.signup.firstname.placeholder',
    defaultMessage: 'Enter your first name',
  },
  signup_lastname: {
    id: 'djcity.common.marketing.promo.signup.lastname.placeholder',
    defaultMessage: 'Enter your last name',
  },
  signup_email: {
    id: 'djcity.common.marketing.promo.signup.email.placeholder',
    defaultMessage: 'Enter your email',
  },
  signup_password: {
    id: 'djcity.common.marketing.promo.signup.password.placeholder',
    defaultMessage: 'Enter your password',
  },
})

export const testimonialsMessages = [
  defineMessages({
    url: {
      id: 'djcity.common.marketing.testimonials.url.1',
      defaultMessage: '/assets/cdn/testimonials/testimonial_1.png',
    },
    text: {
      id: 'djcity.common.marketing.testimonials.text.1',
      defaultMessage:
        '“With monthly charts of the most downloaded songs and trending tracks picked by DJs in the know, DJcity is a great hub for staying connected to what’s cool and in.”',
    },
  }),
  defineMessages({
    url: {
      id: 'djcity.common.marketing.testimonials.url.2',
      defaultMessage: '/assets/cdn/testimonials/testimonial_2.png',
    },
    text: {
      id: 'djcity.common.marketing.testimonials.text.2',
      defaultMessage:
        '“One of the biggest and most popular DJ pools in the market. Clean, and easy to use, DJcity has an in-house production team that creates re-drums and edits, so you can get access to one-of-a-kind stuff!”',
    },
  }),
  defineMessages({
    url: {
      id: 'djcity.common.marketing.testimonials.url.3',
      defaultMessage: '/assets/cdn/testimonials/testimonial_3.png',
    },
    text: {
      id: 'djcity.common.marketing.testimonials.text.3',
      defaultMessage:
        '“It has a great user experience, including an impressive mobile app, and lots of exclusive remixes and useful curated playlists.”',
    },
  }),
  defineMessages({
    url: {
      id: 'djcity.common.marketing.testimonials.url.4',
      defaultMessage: '/assets/cdn/testimonials/testimonial_4.png',
    },
    text: {
      id: 'djcity.common.marketing.testimonials.text.4',
      defaultMessage:
        '“I love going to DJcity once a week to check out their latest uploads. They have a lot of cool original tracks and mash-ups which I pick for my live-sets or radio show!”',
    },
  }),
  defineMessages({
    url: {
      id: 'djcity.common.marketing.testimonials.url.5',
      defaultMessage: '/assets/cdn/testimonials/testimonial_5.png',
    },
    text: {
      id: 'djcity.common.marketing.testimonials.text.5',
      defaultMessage:
        "“Big shout out to DJcity - that's the first place I go to get my music in the whole world.  You guys were the very first, got tons of exclusives, and are blowing it up every time!”",
    },
  }),
  defineMessages({
    url: {
      id: 'djcity.common.marketing.testimonials.url.6',
      defaultMessage: '/assets/cdn/testimonials/testimonial_6.png',
    },
    text: {
      id: 'djcity.common.marketing.testimonials.text.6',
      defaultMessage:
        '“Shout out to all the DJs on DJcity - the #1 website in the world!”',
    },
  }),
]

export const faqMessages = [
  {
    uuid: '1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p6',
    msg: defineMessages({
      question: {
        id: 'djcity.common.marketing.faq1.question',
        defaultMessage: 'What is DJcity?',
      },
      answer: {
        id: 'djcity.common.marketing.faq1.answer',
        defaultMessage:
          'DJcity is a music discovery and delivery platform for DJs, offering a vast library of tracks, curated playlists, and exclusive remixes.',
      },
    }),
  },
  {
    uuid: '2b3c4d5e-6f7g-8h9i-0j1k-2l3m4n5o6p7q',
    msg: defineMessages({
      question: {
        id: 'djcity.common.marketing.faq2.question',
        defaultMessage: 'Does DJcity work with Serato and other DJ software?',
      },
      answer: {
        id: 'djcity.common.marketing.faq2.answer',
        defaultMessage:
          'Yes! All music downloaded from DJcity is compatible with Serato, Rekordbox, Virtual DJ, Traktor, and other major DJ software.<br><br><a href="/integrations">Learn more about DJ software integration here.</a>',
      },
    }),
  },
  {
    uuid: '3c4d5e6f-7g8h-9i0j-1k2l-3m4n5o6p7q8r',
    msg: defineMessages({
      question: {
        id: 'djcity.common.marketing.faq3.question',
        defaultMessage: 'How much does DJcity cost?',
      },
      answer: {
        id: 'djcity.common.marketing.faq3.answer',
        defaultMessage:
          'DJcity offers a subscription model with various pricing tiers. The cost depends on the region and the type of subscription you choose. <br><br>Check out our <a href="/#pricing">pricing section</a> for more details.',
      },
    }),
  },
  {
    uuid: '4d5e6f7g-8h9i-0j1k-2l3m-4n5o6p7q8r9s',
    msg: defineMessages({
      question: {
        id: 'djcity.common.marketing.faq4.question',
        defaultMessage: 'Why is DJcity better than other record pools?',
      },
      answer: {
        id: 'djcity.common.marketing.faq4.answer',
        defaultMessage:
          'DJcity is known for its high-quality tracks, exclusive remixes, and curated playlists. It offers a user-friendly interface, seamless integration with DJ software, and a vast library of music across various genres. <br><br>Many DJs prefer DJcity for its reliability and the quality of its content.',
      },
    }),
  },
]
